export default __webpack_public_path__ + "static/media/mb.1a5a2387.webp";